/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
7/14/20
Irrigation Manage
**********************************************************/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { prepareEditData, handleValveHours, handleEngineHours,
  handleMeterGallons, selectIrrigationLogToEdit, editIrrigation,
  deleteIrrigation } from './irrigation_actions';
import { packageForm, preFillForm, preFillMeterForm, filterOldRecords } from './irrigation_utils';
import IrrigationForm from './components/irrigation_form';
import FooterModal from './components/footer_modal';
import IrrigationDisplay from './components/irrigation_display';

const propTypes = {
  employees: PropTypes.array,
  engines: PropTypes.array,
  meters: PropTypes.array,
  valves: PropTypes.array,
  user: PropTypes.object,
  handleEngineHours: PropTypes.func,
  handleValveHours: PropTypes.func,
  handleMeterGallons: PropTypes.func,
  deleteIrrigation: PropTypes.func
};

const SpanList = ({ list, log, id, prop, _class }) => {
  return (
    <div className={_class}>
      {
        log.map((m, ind) => {
          let _m = list.find((l) => l.id === m[id]);
          if (ind === log.length - 1) return <span key={m.id}>{ _m[prop] }</span>;
          else return <span key={m.id}>{ _m[prop] }, </span>;
        })
      }
    </div>
  )
};

class IrrigationManage extends Component {
  componentDidMount() {
    if (this.props.app.engineLog.length > 0 && this.props.employees.length > 0) {
      let name = 'N/A';
      let emp = this.props.employees.find((e) => Number(e.id) === Number(this.props.app.data.employee));
      if (emp) name = `${emp.firstName} ${emp.lastName}`;
      document.getElementById('irrigation-date').value = moment(this.props.app.data.date).format('YYYY-MM-DD');
      document.getElementById('irrigation-notes').value = this.props.app.data.notes;
      document.getElementById('irrigation-employee').value = name;
      preFillForm({ data: this.props.app.engineLog.map((e) => { return { ...e, id: e.engineId } }), formId: 'engine-form', prop: 'hours' });
      preFillForm({ data: this.props.app.valveLog.map((e) => { return { ...e, id: e.valveId } }), formId: 'valve-form', prop: 'hours', style: true });
      preFillMeterForm({data: this.props.app.meterLog, formId: 'meter-form' });
    }
  }
  render() {
    return (
      <div>
        <div className="row">
          <div className="col s12 m2 l2 xl2">
            <div className="irrigation-table">
              <div className="card">
                <ul className="collection">
                  {
                    this.props.irrigationLogs.filter(filterOldRecords).map((c) => (
                      <li key={c.id} className="collection-item chem-list-item">
                        <span>
                          <b>{ moment(c.date).format('MM/DD/YYYY') }, Meter(s):</b><br />
                          <SpanList log={c.meterLog} list={this.props.meters} id={'meterId'} prop={'meterNo'} />
                        </span>
                        <div className="meter-flex">
                          <button className="btn btn-small blue irr-manage-btn waves-effect" onClick={() => this.props.selectIrrigationLogToEdit({i: c, employees: this.props.employees})}>Edit</button>
                          <a className="waves-effect waves-light btn btn-small irr-manage-btn red modal-trigger" href={`#irrigation-delete-${c.id}`}>
                            Delete
                          </a>
                        </div>
                        {
                          FooterModal(IrrigationDisplay)
                          // eslint-disable-next-line
                          ({
                            id: `irrigation-delete-${c.id}`,
                            employees: this.props.employees,
                            engines: this.props.engines,
                            meters: this.props.meters,
                            valves: this.props.valves,
                            app: { data: { ...c }, engineLog: c.engineLog, meterLog: c.meterLog, valveLog: c.valveLog },
                            view: false,
                            footer: true,
                            toDelete: true,
                            onClick: () => this.props.deleteIrrigation(c.irrigationId)
                          })
                        }
                      </li>
                    ))
                  }
                </ul>
              </div>
            </div>
          </div>
          <div className="col s12 m10 l10 xl10">
            <IrrigationForm formId={'irrigation-edit-form'} employees={this.props.employees} engines={this.props.engines} meters={this.props.meters}
              valves={this.props.valves} handleEngineHours={this.props.handleEngineHours} handleMeterGallons={this.props.handleMeterGallons}
              handleValveHours={this.props.handleValveHours} edit={true} />
            <div className="row">
              <center>
                <a className="waves-effect waves-light btn modal-trigger" href={'#irrigation-edit-log-prepare'}
                  onClick={() => this.props.prepareEditData({
                    user: this.props.user,
                    irrigationId: this.props.app.data.irrigationId,
                    engineLog: this.props.app.engineLog,
                    meterLog: this.props.app.meterLog,
                    valveLog: this.props.app.valveLog,
                    formData: packageForm('irrigation-edit-form')
                  })}>
                  Prepare
                </a>
              </center>
              {
                FooterModal(IrrigationDisplay)
                // eslint-disable-next-line
                ({
                  id: 'irrigation-edit-log-prepare',
                  employees: this.props.employees,
                  engines: this.props.engines,
                  meters: this.props.meters,
                  valves: this.props.valves,
                  app: this.props.app,
                  view: false,
                  footer: true,
                  onClick: () => this.props.editIrrigation({
                    app: this.props.app,
                    deleted: this.props.deleted,
                    employees: this.props.employees,
                    formId: 'irrigation-edit-form'
                  })
                })
              }
            </div>
          </div>

        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    app: state.irrigation.edit.app,
    deleted: state.irrigation.edit.deleted,
    employees: state.irrigation.utils.employees,
    engines: state.irrigation.utils.engines,
    irrigationLogs: state.irrigation.view.displaying,
    meters: state.irrigation.utils.meters,
    user: state.auth.user,
    valves: state.irrigation.utils.valves
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    deleteIrrigation,
    editIrrigation,
    handleEngineHours,
    handleMeterGallons,
    handleValveHours,
    prepareEditData,
    selectIrrigationLogToEdit
  }, dispatch);
}

IrrigationManage.propTypes = propTypes;
export default connect(mapStateToProps, mapDispatchToProps)(IrrigationManage);



/* END */



// WEBPACK FOOTER //
// ./src/irrigation/irrigation_manage.js